import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import NavbarComponent from './components/Navbar/Navbar';
import Home from "./pages/Home/Home";
import Despre from "./pages/Despre/Despre";
import MeditatiiElevi from "./pages/Meditatii/MeditatiiElevi";
import MeditatiiStudenti from "./pages/Meditatii/MeditatiiStudenti";
import MeditatiiProfesori from "./pages/Meditatii/MeditatiiProfesori";
import Portofoliu from "./pages/Portofoliu/Portofoliu";
import Simulari from "./pages/Simulari/Simulari";
import Titularizare from "./pages/Titularizare/Titularizare";
import Definitivat from "./pages/Definitivat/Definitivat";
import Grade from "./pages/Grade/Grade";
import Olimpiade from "./pages/Olimpiade/Olimpiade";
import Carte from "./pages/Carte/Carte";
import Blog from "./pages/Blog/Components/Blog";
import BlogPost from "./pages/Blog/Components/BlogPost";
import Subiecte from "./pages/Subiecte/Subiecte";
import Contact from "./pages/Contact/Contact";
import Confidentialitate from "./pages/Politici/Confidentialitate";
import Termeni from "./pages/Politici/Termeni";
import FooterComponent from "./components/Footer/Footer";
import Error404 from "./pages/Error404/Error404";

//import Snowfall from "react-snowfall";

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App() {
    return (
        <Router>
            {/*<Snowfall
                color="#FFFFFF"
                style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    zIndex: 9999,
                    pointerEvents: "none",
                }}
            />
            */}
            <NavbarComponent/>
            <Routes>
                <Route exact path="/" element={<Home/>}/>
                <Route path="/despre" element={<Despre/>}/>
                <Route path="/meditatii-elevi" element={<MeditatiiElevi/>}/>
                <Route path="/meditatii-studenti" element={<MeditatiiStudenti/>}/>
                <Route path="/meditatii-profesori" element={<MeditatiiProfesori/>}/>
                <Route path="/portofoliu" element={<Portofoliu/>}/>
                <Route path="/simulari" element={<Simulari/>}/>
                <Route path="/titularizare" element={<Titularizare/>}/>
                <Route path="/definitivat" element={<Definitivat/>}/>
                <Route path="/grade" element={<Grade/>}/>
                <Route path="/olimpiade" element={<Olimpiade/>}/>
                <Route path="/algoritmi-si-rezolvari" element={<Carte/>}/>
                <Route path="/subiecte/:yearId" element={<Subiecte />}/>
                <Route path="/blog" element={<Blog/>}/>
                <Route path="/blog/:id" element={<BlogPost/>}/>
                <Route path="/subiecte" element={<Navigate to="/subiecte/2027" replace/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/confidentialitate" element={<Confidentialitate/>}/>
                <Route path="/termeni" element={<Termeni/>}/>
                <Route path="*" element={<Error404/>}/>
            </Routes>
            <FooterComponent/>
        </Router>
    )
}